<template>
    <iframe ref="dociframe" width="0" height="0" style="border:none; height: 0px; width: 0px; display: block;">
        
    </iframe>
</template>

<script>


export default {
  name: 'GrcDocDisplayer',
  components: {
  },
  props: {
  },
  data () {
      return {

      }
  },
  model: {
  },  
  methods:{

        ShowFile(pDocDataB64, pFileName, pDisplayFileName)
        {
            var res = "";

            var ext = grcmain_getFileExtension(pFileName);

            if (ext == "jpeg") { ext = "jpg"; }

            var mt = "";

            if (ext == "pdf") { mt = "application/pdf"; }
            if (ext == "jpg") { mt = "image/jpeg"; }
            if (ext == "png") { mt = "image/png"; }
            if (ext == "tif") { mt = "image/tiff"; }

            if (mt == "")
            {
                res = "Hiba a dokumentum megnyitásakor (ismeretlen fájltípus)!";
                return res;
            }

            if (pDisplayFileName != "")
            {
                if (pDisplayFileName.includes(".") == false)
                {
                    pFileName = pDisplayFileName + "." + ext;
                }
            }

            var DocData = this.b64toBlob(pDocDataB64, mt);

            var agent = grcmain_GetAgent();

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(DocData, pFileName);  
            }
            else 
            {
                var fileURL = URL.createObjectURL(DocData);

                if (agent == "SAFARI")
                {
                    var link = this.$refs.dociframe.contentWindow.document.createElement('a');
                    link.href = fileURL;
                    link.download = pFileName;
                }
                else
                {
                    var link = document.createElement('a');
                    link.href = fileURL;
                    link.target = "_blank";
                }
                
                link.click();            
            }

            return res;
        },        

        b64toBlob(dataURI, pType) 
        {
            var byteString = atob(dataURI);
            var ab = new ArrayBuffer(byteString.length);
            var ia = new Uint8Array(ab);

            for (var i = 0; i < byteString.length; i++) 
            {
                ia[i] = byteString.charCodeAt(i);
            }
            return new Blob([ab], { type: pType });
        },





  },
  created()
  {

  },
  mounted()
  {
      //this.$refs.dociframe.srcdoc="hello";

  }

}


</script>


<style scoped>

.errorbox
{
    position: relative;
    background: lightcoral;
    border-radius: 2px 2px 2px 2px;
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    font-family: "PremiumDefault";
    font-size: 14px;
    line-height: 20px;
    color: #fff;
    margin-top: 8px;
    padding: 8px;
    margin-bottom: 16px;    
}


</style>